import React, { useState } from 'react';
import { useAllSubscriptionsQuery, useCreateSubscriptionMutation, useDeleteSubscriptionByIdMutation, useUpdateSubscriptionByIdMutation } from '../../../store/api/subscription.api';
import styles from './SubsAdminPage.module.css';
import { SubModal } from '../Modal/SubModal/SubModal';
import { useNavigate } from 'react-router-dom';

export const SubsAdminPage = () => {
	const { data: subs = [], isLoading, refetch } = useAllSubscriptionsQuery();
	const [createMode, setCreateMode] = useState(false);
	const [searchQuery, setSearchQuery] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage] = useState(20);
	const [activeMenu, setActiveMenu] = useState(null);
	const [editSubId, setEditSubId] = useState(null);

	const [createSub] = useCreateSubscriptionMutation();
	const [deleteSub] = useDeleteSubscriptionByIdMutation();
	const [editSub] = useUpdateSubscriptionByIdMutation(); 
	const handleCloseModal = () => {
		setCreateMode(false);
		setEditSubId(null);
	};
	const navigate = useNavigate();

	const handleSubSubmit = async (formData) => {
		try {
			if (editSubId) {
				await editSub({ id: editSubId, data: formData }).unwrap();
			} else {
				// Create new subscription
				await createSub(formData).unwrap();
			}
			refetch(); // Обновление списка подписок
		} catch (error) {
			alert('Ошибка при добавлении/обновлении подписки');
		}
		handleCloseModal();
	};

	const handleDelete = async (subId) => {
		if (window.confirm('Вы уверены, что хотите удалить эту подписку?')) {
			try {
				await deleteSub(subId).unwrap();
				refetch();
			} catch (error) {
				alert('Ошибка при удалении подписки');
			}
		}
	};

	const handleMenuToggle = (subId) => {
		setActiveMenu((prev) => (prev === subId ? null : subId)); // Toggle menu visibility
	};

	const handleEdit = (subId) => {
		setEditSubId(subId); // Set subscription ID for editing
		setActiveMenu(null); // Close menu
	};

	if (isLoading) {
		return <div className={styles.loading}>Загрузка...</div>;
	}

	// Фильтрация подписок по названию
	const filteredSubs = subs.filter(sub =>
		sub.title.toLowerCase().includes(searchQuery.toLowerCase())
	);

	// Определяем, какие подписки показывать на текущей странице
	const indexOfLastSub = currentPage * itemsPerPage;
	const indexOfFirstSub = indexOfLastSub - itemsPerPage;
	const currentSubs = filteredSubs.slice(indexOfFirstSub, indexOfLastSub);

	// Рассчитываем количество страниц
	const totalPages = Math.ceil(filteredSubs.length / itemsPerPage);

	// Переключение на предыдущую страницу
	const handlePageChange = (newPage) => {
		if (newPage >= 1 && newPage <= totalPages) {
			setCurrentPage(newPage);
		}
	};

	return (
		<div className={styles.main}>
			<button onClick={() => navigate(-1)} className={styles.backButton}>
				← Назад
			</button>
			<h2 className={styles.title}>Подписки</h2>

			<div className={styles.buttonWrapper}>
				<button className={styles.addButton} onClick={() => setCreateMode(true)}>
					Добавить подписку
				</button>
			</div>

			{/* Поиск */}
			<div className={styles.searchWrapper}>
				<input
					type="text"
					value={searchQuery}
					onChange={(e) => setSearchQuery(e.target.value)}
					placeholder="Поиск по названию..."
					className={styles.searchInput}
				/>
			</div>

			<div className={styles.header}>
				<div>ID</div>
				<div>Название</div>
				<div>Категория</div>
				<div>Время (мес.)</div>
				<div>Цена</div>
				<div>Действия</div>
			</div>

			<div className={styles.list}>
				{currentSubs.map((sub) => (
					<div key={sub.id} className={styles.row}>
						<div>{sub.id}</div>
						<div>{sub.title}</div>
						<div>{sub.category || '-'}</div>
						<div>{sub.time || '-'}</div>
						<div>{sub.price} ₽</div>
						<div className={styles.actions}>
							<div onClick={() => handleMenuToggle(sub.id)} className={styles.menuIcon}>
								⋮
							</div>
							{activeMenu === sub.id && (
								<div className={styles.menu}>
									<div onClick={() => handleEdit(sub.id)}>Изменить</div>
									<div onClick={() => handleDelete(sub.id)}>Удалить</div>
								</div>
							)}
						</div>
					</div>
				))}
			</div>

			{/* Пагинация */}
			<div className={styles.pagination}>
				<button
					onClick={() => handlePageChange(currentPage - 1)}
					disabled={currentPage === 1}
					className={styles.pageButton}
				>
					Назад
				</button>
				<span className={styles.pageInfo}>
					Страница {currentPage} из {totalPages}
				</span>
				<button
					onClick={() => handlePageChange(currentPage + 1)}
					disabled={currentPage === totalPages}
					className={styles.pageButton}
				>
					Вперёд
				</button>
			</div>

			{/* Модалка для добавления/редактирования подписки */}
			{(createMode || editSubId) && (
				<SubModal
					isOpen={createMode || editSubId}
					onClose={handleCloseModal}
					onSubmit={handleSubSubmit}
					sub={editSubId ? subs.find((sub) => sub.id === editSubId) : null}
				/>
			)}
		</div>
	);
};
